import { Input } from "./ui";
import { useState } from "react";

// Helper function to format numbers without unnecessary trailing zeros
const formatNumber = (num) => {
    return Number(num.toFixed(1));
};

const WindowEdit = (props) => {

    const [windowWidth, setWidth] = useState(props.floorplanner.getWindowDimensions().w);
    const [windowHeight, setHeight] = useState(props.floorplanner.getWindowDimensions().h);

    const handleWidthChange = (newWidth)=>{
        setWidth(newWidth);
        props.floorplanner.setWindowDimensions(newWidth, windowHeight);
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: "180px",
            padding: "10px",
            gap: "5px",
        }}>
            <label style={{ fontSize: "12px", alignSelf: "flex-start", marginBottom: "-2px" }}>
                Window width (cm)
            </label>
            <Input type="number"
                step={0.1}
                value={formatNumber(windowWidth)} 
                onChange={(evt)=>{handleWidthChange(evt.target.value)}}/>
        </div>
    )
}

export default WindowEdit;